<template>
  <div
    class="notice-overlay"
    :class="{ 'notice-overlay-visible': showNotice }"
    @click="closeNotice"
  >
    <div
      @click="
        event => {
          event.stopPropagation()
        }
      "
      class="notice-lists"
    >
      <h4 class="notice-title">
        <span
          v-if="noticeType === 'official'"
          @click="noticeType = 'user'"
          class="hitems-arrow-left"
        ></span>
        <span
          v-if="noticeType === 'order'"
          @click="noticeType = 'user'"
          class="hitems-arrow-left"
        ></span>
        <span v-if="noticeType === 'user'" class="notice-title-text">消息</span>
        <span v-else-if="noticeType === 'order'" class="notice-title-text">订单</span>
        <span v-else class="notice-title-text">{{ $t('appNotice.officicial') }}</span>
        <a v-if="noticeType === 'user'" class="notice-read-all" @click="readAll">
          {{ $t('appNotice.read_all') }}
        </a>
      </h4>
      <div class="notice-lists-box">
        <div class="notice-lists-content" key="user" v-if="noticeType === 'user'">
          <!-- 系统消息外露 -->
          <div
            class="notice-lists-item system-items"
            @click="
              event => {
                event.stopPropagation()
                noticeType = 'official'
              }
            "
            v-for="item in noticeSystemFirstItem"
            :key="item.msgId"
          >
            <div class="notice-user-avatar official">
              <span v-if="allUnreadNums.systemCount > 0" class="tip-nums">
                +{{ allUnreadNums.systemCount }}
              </span>
              <img
                class="official-avatar"
                alt="official"
                :src="msgIcon"
                width="100%"
                height="100%"
              />
            </div>
            <div class="notice-content">
              <p class="notice-user-name" :title="item.userInfo.nickname">{{ officialName }}</p>
              <p class="notice-user-msg">
                {{
                  renderOfficial(
                    Number(item.type),
                    item.info?.conditionNum,
                    $t,
                    item?.info?.topicTitle,
                    item
                  )
                }}
                <a class="notice-user-msg-link" v-if="item.type === 9 || item.type === 6">
                  {{ $t('appNotice.view_page') }}
                </a>
                <a
                  class="notice-user-msg-link"
                  v-else-if="item.type === 100 && item.payloadJson?.attachments"
                  v-for="(attachment, index) in item.payloadJson.attachments"
                  :key="index"
                  @click.stop="clickAttachment(attachment)"
                >
                  {{ attachment.web_text }}
                </a>
                <template
                  v-if="(item.type === 7 || item.type == 20 || item.type == 21) && _env_ === 'CN'"
                >
                  (
                  <span>点击查看二维码</span>
                  <span @click="event => event.stopPropagation()" class="weixin-code">
                    <AppImage :src="weixinCode" :fullscreen="weixinCode" />
                  </span>
                  )
                </template>
                <a class="notice-user-msg-link" v-if="item.type === 5 || item.type === 19">
                  {{ $t('appNotice.fill_in_your_shipping') }}
                </a>
              </p>
              <p class="notice-user-msg" v-if="item.type === 22">
                {{ item.info.rankingMsg }}
                <a
                  @click="clickNotice(item.msgId, item.contentId, item)"
                  href="javascript:;"
                  class="notice-user-msg-link"
                  rel="noopener noreferrer"
                >
                  查看榜单>>
                </a>
              </p>
              <p class="notice-user-msg" v-if="item.type === 0">
                <span v-html="item?.payloadJson?.content?.replace(/<br\s*\/?>/gi, '')"></span>
                <a
                  v-if="item?.payloadJson?.landing_url"
                  @click="clickNotice(item.msgId, item.contentId, item)"
                  href="javascript:;"
                  class="notice-user-msg-link"
                  rel="noopener noreferrer"
                >
                  立即体验>>
                </a>
              </p>
              <!-- 作品删除 通知wantit 用户 -->
              <p v-if="item.type === 18" class="notice-user-msg">
                很遗憾，您之前「想要」的作品刚刚被作者删除了。不过别担心，我们已将您的「想要」次数全额退还！期待您发现更多喜欢的作品！
              </p>
              <p class="notice-time">{{ item.localDateTime }}</p>
            </div>
            <div v-if="item.posterImage && item.posterImage.length > 0" class="img-box">
              <img
                class="notice-user-post"
                alt="User Post"
                :src="
                  item.posterImage[0].imageResize200Url ||
                  item.posterImage[0].firstFrameResize200Url
                "
              />
              <div class="video-tag" v-if="item.contentType === 'video'">
                <span class="hitems-video-play"></span>
              </div>
            </div>

            <img
              v-else-if="item.type !== 0 && isImageUrlValid(item.payloadJson?.web_popup_image)"
              class="notice-user-post"
              :src="item.payloadJson.web_popup_image"
            />
          </div>

          <!-- 用户消息list -->
          <div
            v-for="item in noticeItems"
            :key="item.msgId"
            @click.stop="clickNotice(item.msgId, item.contentId, item)"
            :class="['notice-lists-item', { read: item.readFlag === 1 }]"
          >
            <div v-if="item.entrance === 1" class="order-icon" @click.stop="noticeType = 'order'">
              <span v-if="allUnreadNums.tradeCount > 0" class="tip-nums">
                +{{ allUnreadNums.tradeCount }}
              </span>
              <span class="hitems-a-icon_buy1"></span>
            </div>
            <div
              v-else
              class="notice-user-avatar"
              @click.stop="clickNoticeAvatar(item.userInfo.id, item)"
            >
              <span class="tip"></span>
              <img alt="User" :src="item.userInfo.avatar" width="100%" height="100%" />
              <span :class="['tip-type', getNoticeIcon(Number(item.type))]"></span>
            </div>
            <div class="notice-content">
              <p
                v-if="item.entrance === 1"
                class="notice-user-name font-semibold"
                @click.stop="noticeType = 'order'"
              >
                订单通知
              </p>
              <p
                v-else
                class="notice-user-name font-semibold"
                @click.stop="clickNoticeAvatar(item.userInfo.id, item)"
                :title="item.userInfo.nickname"
              >
                {{ item.userInfo.nickname }}
              </p>
              <p
                v-if="item.type === 1"
                @click="clickNotice(item.msgId, item.contentId, item)"
                class="notice-user-msg"
              >
                {{ $t('appNotice.liked_your_work') }}
              </p>
              <p
                v-if="item.type === 4"
                @click="clickNotice(item.msgId, item.contentId, item)"
                class="notice-user-msg"
              >
                {{ $t('appNotice.wanted_your_work') }}
                <span
                  v-if="
                    item.info &&
                    item.info.wantItConditionNums &&
                    item.info.wantItTicketCount != null
                  "
                  class="progress-info"
                >
                  ，免费获得实物进度
                  <span class="progress-text">
                    {{ item.info.wantItTicketCount }}/{{ item.info.wantItConditionNums }}
                  </span>
                </span>
              </p>
              <p
                v-if="item.type === 10"
                @click="clickNotice(item.msgId, item.contentId, item)"
                class="notice-user-msg"
              >
                {{ $t('appNotice.followed_you') }}
              </p>
              <p
                v-if="item.type === 11"
                @click="clickNotice(item.msgId, item.contentId, item)"
                class="notice-user-msg"
              >
                {{ $t('appNotice.follow_back_you') }}
              </p>
              <p
                v-if="item.type === 12"
                @click="clickNotice(item.msgId, item.contentId, item)"
                class="notice-user-msg"
              >
                {{ $t('appNotice.commented_your_work') }}
              </p>
              <p
                v-if="item.type === 13"
                @click="clickNotice(item.msgId, item.contentId, item)"
                class="notice-user-msg"
              >
                {{ $t('appNotice.repiled_your_comment') }}
              </p>
              <!-- 提及 -->
              <p
                v-if="item.type === 23 && item.info.mentionType === 1"
                @click="clickNotice(item.msgId, item.contentId, item)"
                class="notice-user-msg"
              >
                在评论区@了你
              </p>
              <p
                v-if="item.type === 23 && item.info.mentionType === 2"
                @click="clickNotice(item.msgId, item.contentId, item)"
                class="notice-user-msg"
              >
                在作品中@了你
              </p>
              <!-- 支付完成 -->
              <p v-if="item.type === 14" @click.stop="noticeType = 'order'" class="notice-user-msg">
                您的订单 #{{ item.info.orderId }} 已完成支付。 商品：{{ item.info.product_name }}
                <a class="notice-user-msg-link">查看订单详情>></a>
              </p>
              <!-- 生产完成 -->
              <p v-if="item.type === 15" @click.stop="noticeType = 'order'" class="notice-user-msg">
                您的专属{{ item.info.product_name }}已进入制作阶段 ；订单编号：{{
                  item.info.orderId
                }}
                <a class="notice-user-msg-link">查看订单详情>></a>
              </p>
              <!-- 退款 -->
              <p v-if="item.type === 16" @click.stop="noticeType = 'order'" class="notice-user-msg">
                非常抱歉，您在造好物平台的订单#{{ item.info.orderId }}暂无法生产。已退还{{
                  item.info.payAmount
                }}元至原账户，可重新设计或联系客服小助手
                <a class="notice-user-msg-link">查看订单详情>></a>
              </p>
              <!-- 已发货 -->
              <p v-if="item.type === 17" @click.stop="noticeType = 'order'" class="notice-user-msg">
                您的订单#{{
                  item.info.orderId
                }}已经发货，请注意查收，签收前请验货！如果对商品有疑问，请联系客服小助手
                <a class="notice-user-msg-link">查看订单详情>></a>
              </p>
              <p class="notice-user-time">{{ item.localDateTime }}</p>
            </div>
            <div class="img-box" v-if="item.posterImage && item.posterImage.length > 0">
              <img
                class="notice-user-post"
                @click="clickNotice(item.msgId, item.contentId, item)"
                alt="User Post"
                :src="
                  item.posterImage[0].imageResize200Url ||
                  item.posterImage[0].firstFrameResize200Url
                "
              />
              <div class="video-tag" v-if="item.contentType === 'video'">
                <span class="hitems-video-play"></span>
              </div>
            </div>
            <img
              v-if="item.info && item.info.product_image"
              class="notice-user-post"
              @click="clickNotice(item.msgId, item.contentId, item)"
              alt="User Post"
              :src="decodeURIComponent(item.info.product_image)"
            />

            <template v-if="item.userInfo">
              <div class="notice-post-action" v-if="!item.userInfo.following">
                <AppFollow
                  v-if="(item.type === 10 || item.type === 11) && item.userInfo.display"
                  :following="item.userInfo.following"
                  :id="item.userInfo.id"
                  :followText="$t('appNotice.followed_back')"
                  @follow="
                    val => {
                      followUser(item, val)
                    }
                  "
                />
              </div>
              <div class="notice-post-action" v-else>
                <span v-if="item.type === 10 || item.type === 11" class="followed">
                  {{ $t('appNotice.followed_back') }}
                </span>
              </div>
            </template>
          </div>
        </div>

        <!-- 系统消息list -->
        <transition name="slide">
          <div class="notice-lists-content" key="official" v-if="noticeType === 'official'">
            <div
              v-for="item in noticeSystemItems"
              :class="['notice-lists-item', { read: item.readFlag === 1 }]"
              :key="item.msgId"
            >
              <div class="notice-user-avatar official">
                <span class="tip"></span>
                <img
                  class="official-avatar"
                  alt="official"
                  :src="msgIcon"
                  width="100%"
                  height="100%"
                />
              </div>
              <div class="notice-content" @click="clickNotice(item.msgId, item.contentId, item)">
                <p class="notice-user-name" :title="item.userInfo.nickname">{{ officialName }}</p>
                <p class="notice-user-msg">
                  <span v-if="item.info && item.info.returnReason">
                    非常抱歉，因为{{ item.info.returnReason }}，
                  </span>
                  {{
                    renderOfficial(
                      Number(item.type),
                      item.info?.conditionNum,
                      $t,
                      item?.info?.topicTitle,
                      item
                    )
                  }}
                  <a
                    v-if="item.type === 7 && _env_ === 'EN'"
                    class="notice-user-msg-link"
                    href="https://hitems.shop"
                    target="_blank"
                  >
                    {{ $t('appNotice.hitems_shop') }}
                  </a>
                  <span
                    @click="event => event.stopPropagation()"
                    v-if="
                      item.type === 6 || item.type === 7 || item.type === 20 || item.type === 21
                    "
                    class="notice-user-msg-code font-black"
                  >
                    (
                    <span v-if="item.info.discount">
                      {{ $t('appNotice.off1') }}{{ 100 - item.info.discount * 100 }}%{{
                        $t('appNotice.off')
                      }}
                    </span>
                    <template
                      v-if="
                        (item.type === 7 || item.type === 20 || item.type === 21) && _env_ === 'CN'
                      "
                    >
                      <span>点击查看二维码</span>
                      <span @click="event => event.stopPropagation()" class="weixin-code">
                        <AppImage :src="weixinCode" :fullscreen="weixinCode" />
                      </span>
                    </template>
                    <span v-if="item.type === 7 && _env_ === 'EN'">
                      100%{{ $t('appNotice.off') }}
                    </span>
                    <!-- {{ $t("appNotice.code") }} {{ item.info.discountCoupon }} -->
                    <!-- <span v-if="item.type === 7">
                                            , use in <a class="notice-user-msg-link" href="https://hitems.shop" target="_blank">hitems.shop</a>
                                        </span> -->
                    )
                  </span>
                  <a
                    class="notice-user-msg-link"
                    v-if="item.type === 9 || item.type === 6"
                    @click.stop="clickProductLink(item)"
                  >
                    {{ $t('appNotice.view_page') }}
                  </a>
                  <a
                    class="notice-user-msg-link"
                    @click.stop="clickProductLink(item)"
                    v-else-if="item.type === 5 || item.type === 19"
                  >
                    {{ $t('appNotice.fill_in_your_shipping') }}
                  </a>
                  <a
                    class="notice-user-msg-link"
                    v-else-if="item.type === 100 && item.payloadJson?.attachments"
                    v-for="(attachment, index) in item.payloadJson.attachments"
                    :key="index"
                    @click.stop="clickAttachment(attachment)"
                  >
                    {{ attachment.web_text }}
                  </a>
                </p>
                <p class="notice-user-msg" v-if="item.type === 22">
                  <span style="font-weight: 600">{{ item.payloadJson?.title }}</span>
                  {{ item.info?.rankingMsg }}
                  <a
                    @click="clickNotice(item.msgId, item.contentId, item)"
                    href="javascript:;"
                    class="notice-user-msg-link"
                    rel="noopener noreferrer"
                  >
                    查看榜单>>
                  </a>
                </p>
                <p class="notice-user-msg" v-if="item.type === 0">
                  <span v-html="item?.payloadJson?.content?.replace(/<br\s*\/?>/gi, '')"></span>
                  <a
                    @click="clickNotice(item.msgId, item.contentId, item)"
                    v-if="item?.payloadJson?.landing_url"
                    href="javascript:;"
                    class="notice-user-msg-link"
                    rel="noopener noreferrer"
                  >
                    立即体验>>
                  </a>
                </p>
                <!-- 作品删除 通知wantit 用户 -->
                <p
                  v-if="item.type === 18"
                  @click="clickNotice(item.msgId, item.contentId, item)"
                  class="notice-user-msg"
                >
                  很遗憾，您之前「想要」的作品刚刚被作者删除了。不过别担心，我们已将您的「想要」次数全额退还！期待您发现更多喜欢的作品！
                </p>
                <p class="notice-time">{{ item.localDateTime }}</p>
              </div>
              <div class="img-box" v-if="item.posterImage && item.posterImage.length > 0">
                <img
                  class="notice-user-post"
                  @click="clickNotice(item.msgId, item.contentId, item)"
                  alt="User Post"
                  :src="
                    item.posterImage[0].imageResize200Url ||
                    item.posterImage[0].firstFrameResize200Url
                  "
                />
                <div class="video-tag" v-if="item.contentType === 'video'">
                  <span class="hitems-video-play"></span>
                </div>
              </div>
              <img
                v-else-if="item.type !== 0 && isImageUrlValid(item.payloadJson?.web_popup_image)"
                class="notice-user-post"
                @click="clickNotice(item.msgId, item.contentId, item)"
                :src="item.payloadJson.web_popup_image"
              />
            </div>
          </div>
        </transition>

        <!-- 订单消息 -->
        <transition name="slide">
          <div class="notice-lists-content" key="order" v-if="noticeType === 'order'">
            <div
              v-for="item in orderItems"
              :class="['notice-lists-item', { read: item.readFlag === 1 }]"
              :key="item.msgId"
            >
              <div class="order-icon">
                <span class="tip"></span>
                <span class="hitems-a-icon_buy1"></span>
              </div>
              <div class="notice-content" @click="clickNotice(item.msgId, '', item)">
                <p class="notice-user-name">订单 {{ item.info.orderId }}</p>
                <p class="notice-user-msg">
                  <!-- 支付完成 -->
                  <span v-if="item.type === 14">
                    您的订单已完成支付。 商品：{{ item.info.product_name }}
                    <a class="notice-user-msg-link">查看订单详情>></a>
                  </span>
                  <!-- 生产完成 -->
                  <span v-if="item.type === 15">
                    您的专属{{ item.info.product_name }}已进入制作阶段
                    <a class="notice-user-msg-link">查看订单详情>></a>
                  </span>
                  <!-- 退款 -->
                  <span v-if="item.type === 16">
                    非常抱歉，您在造好物平台的订单暂无法生产。已退还
                    {{ item.info.payAmount }} 元至原账户，可重新设计或联系客服小助手
                    <a class="notice-user-msg-link">查看订单详情>></a>
                  </span>
                  <!-- 已发货 -->
                  <span v-if="item.type === 17">
                    您的订单已经发货，请注意查收，签收前请验货！如果对商品有疑问，请联系客服小助手
                    <a class="notice-user-msg-link">查看订单详情>></a>
                  </span>
                </p>
              </div>
              <div v-if="item.posterImage && item.posterImage.length > 0" class="img-box">
                <img
                  class="notice-user-post"
                  @click="clickNotice(item.msgId, item.contentId, item)"
                  alt="User Post"
                  :src="
                    item.posterImage[0].imageResize200Url ||
                    item.posterImage[0].firstFrameResize200Url
                  "
                />
                <div class="video-tag" v-if="item.contentType === 'video'">
                  <span class="hitems-video-play"></span>
                </div>
              </div>
              <img
                v-else-if="item.info && item.info.product_image"
                class="notice-user-post"
                @click="clickNotice(item.msgId, item.contentId, item)"
                alt="User Post"
                :src="decodeURIComponent(item.info.product_image)"
              />
              <img
                v-else-if="item.type !== 0 && isImageUrlValid(item.payloadJson.web_popup_image)"
                class="notice-user-post"
                @click="clickNotice(item.msgId, item.contentId, item)"
                alt="User Post"
                :src="item.payloadJson.web_popup_image"
              />
            </div>
          </div>
        </transition>

        <div class="notice-lists-item read" v-if="loading">
          <AppLoading />
        </div>
        <div
          class="notice-no-data"
          v-if="
            !loading &&
            noticeItems.length === 0 &&
            noticeSystemItems.length === 0 &&
            noticeType === 'user'
          "
        >
          <img src="@common/assets/images/notice-no-data.webp" width="48" />
          <p>{{ $t('appNotice.no_message') }}</p>
        </div>
      </div>
    </div>
    <AppFullScreenImage
      :src="fullScreenImageSrc"
      :visible="fullScreenImageVisible"
      @close="closeFullScreenImage"
    />
  </div>
</template>

<script lang="ts" setup>
  import { ref, onBeforeUnmount, watchEffect, onMounted } from 'vue'
  import { useRouter } from 'vue-router'
  import _fetch from '@/utils/fetch'
  import type { User } from '@common/types/user'
  import type { Image } from '@common/types/image'
  import { useIsMobile } from '@common/hooks/useIsMobile'
  import { useTicketStore } from '@common/stores/userTicket'
  import AppLoading from '@components/components/AppLoading/AppLoading.vue'
  import { eventBus } from '@common/utils/eventBus'
  import renderOfficial from '@common/utils/renderOfficial'
  import msgIcon from '@common/assets/images/official.webp'
  import AppFollow from '@common/components/AppFollow/AppFollow.vue'
  import { useI18n } from 'vue-i18n'
  import AppImage from '@common/components/AppImage/AppImage.vue'
  import weixinCode from '@common/assets/images/qiyeweixin.webp'
  import { useNoticeStore } from '@common/stores/useNotice'
  import AppFullScreenImage from '@common/components/AppFullScreenImage/index.vue'

  interface NoticeItem {
    msgId: string
    entrance: number | null
    contentId: string
    commentId: string
    payloadJson: any
    type: number
    readFlag: number
    userInfo: User
    posterImage: Image[]
    localDateTime: string
    conditionNum: any
    info: any
    topicId: string
    contentType?: string
  }

  defineOptions({
    name: 'AppNotice'
  })

  const props = defineProps<{
    visible: boolean
    type: string
    base: string
  }>()

  const emit = defineEmits(['notice', 'close'])
  const router = useRouter()
  const ticketStore = useTicketStore()
  const noticeStore = useNoticeStore()
  // 消息中心
  const noticeType = ref('user')
  const showNotice = ref(true)
  const noticeItems = ref<NoticeItem[]>([])
  const noticeSystemItems = ref<NoticeItem[]>([])
  const orderItems = ref<NoticeItem[]>([])
  const noticeSystemFirstItem = ref<NoticeItem[]>([])
  const fullScreenImageVisible = ref(false)
  const fullScreenImageSrc = ref('')
  const { t } = useI18n()
  let source: EventSource | null = null

  const toggleNotice = async (visible: boolean) => {
    showNotice.value = visible
    if (showNotice.value) {
      loading.value = true
      getAllNoticeNum()
      getNoticeItems()
      getOfficialItems()
      getOrderItems()
    }
    eventBus.trigger('closeTicket')
    eventBus.trigger('closeDrawer')
  }

  watchEffect(() => {
    toggleNotice(props.visible)
  })

  const closeNotice = () => {
    showNotice.value = false
    noticeType.value = 'user'
    emit('close')
  }

  eventBus.addEvent('closeNotice', closeNotice)

  onMounted(() => {
    getNoticeNum()
    sseNotify()
  })

  const getNoticeNum = async () => {
    const response = await _fetch('/aigc/api/message/unRead/count')
    const res = await response.json()
    if (res.code === 200) {
      noticeStore.setUnReadCount(res.data)
    }
  }
  const allUnreadNums = ref({
    systemCount: 0,
    normalCount: 0,
    tradeCount: 0
  })
  const getAllNoticeNum = async () => {
    const response = await _fetch('/aigc/api/message/unRead/count/detail')
    const res = await response.json()
    if (res.code === 200) {
      allUnreadNums.value = res.data
    }
  }
  const loading = ref(false)
  const getNoticeItems = async () => {
    const response = await _fetch('/aigc/api/message/list', {
      method: 'GET',
      params: {
        page: 1,
        pageSize: 1000,
        tz: Intl.DateTimeFormat().resolvedOptions().timeZone || ''
      }
    })
    loading.value = false
    const res = await response.json()
    if (res.code === 200) {
      noticeItems.value = res.data.dataList || []
    }
  }
  const getOfficialItems = async () => {
    const response = await _fetch('/aigc/api/message/official/list', {
      method: 'GET',
      params: {
        page: 1,
        pageSize: 1000,
        tz: Intl.DateTimeFormat().resolvedOptions().timeZone || ''
      }
    })
    loading.value = false
    const res = await response.json()
    if (res.code === 200) {
      noticeSystemItems.value = res.data.dataList || []
      noticeSystemFirstItem.value = res.data.dataList[0] ? [res.data.dataList[0]] : []
    }
  }
  const getOrderItems = async () => {
    const response = await _fetch('/aigc/api/message/trade/list', {
      method: 'GET',
      params: {
        page: 1,
        pageSize: 1000,
        tz: Intl.DateTimeFormat().resolvedOptions().timeZone || ''
      }
    })
    loading.value = false
    const res = await response.json()
    if (res.code === 200) {
      orderItems.value = res.data.dataList || []
    }
  }
  // 创建sse
  // 需要系统通知的code
  const needSystemNoticeCodes = [5, 6, 7, 8, 9]
  const sseNotify = () => {
    if ('EventSource' in window) {
      source = new EventSource(
        `/aigc/api/sse/stream?timer=${new Date().getTime()}&tz=${Intl.DateTimeFormat().resolvedOptions().timeZone || ''}`,
        { withCredentials: true }
      )
      source.addEventListener(
        'message',
        function (event: { data: any }) {
          let data = JSON.parse(event.data)
          getNoticeNum()
          // if (data.unReadCount !== 0) {
          //   noticeStore.setUnReadCount(data.unReadCount)
          // }
          // 如果消息通知弹窗开着，则获取对应tab的list数据
          if (showNotice.value) {
            setTimeout(function () {
              getNoticeItems()
              getOfficialItems()
              getOrderItems()
            }, 500)
          }
          // 获取want it票
          if (data.type === 2 || data.type === 3) {
            ticketStore.setSSETicketNmu(data.content?.num)
            ticketStore.setTicket(data.content?.balance)
            ticketStore.setSSETime(data.content?.time)
            ticketStore.setShowTip(true)
            ticketStore.setSSEType(data.type)
          }
          // 系统通知
          if (needSystemNoticeCodes.includes(data.type)) {
            createNotify(
              officialName.value,
              {
                icon: msgIcon,
                body: `${renderOfficial(Number(data.type), data.content?.conditionNum, t, '', data)} ${data.type === 9 || data.type === 6 ? t('appNotice.view_page') + '>>' : ''}`,
                image: data.content?.posterImage[0]?.imageResize200Url,
                dir: 'ltr'
              },
              data.type,
              data.content
            )
          }
        },
        false
      )
    } else {
      alert(t('appNotice.check_browser'))
    }
  }
  // 浏览器通知
  const createNotify = (title: string, options: object, type: number, content: any) => {
    // 用户允许通知
    let PERMISSON_GRANTED = 'granted'
    // 用户拒绝通知
    // var PERMISSON_DENIED = 'denied';
    // var PERMISSON_DEFAULT = 'default';
    if (Notification.permission === PERMISSON_GRANTED) {
      notify(title, options)
    } else {
      Notification.requestPermission(function (res) {
        if (res === PERMISSON_GRANTED) {
          notify(title, options)
        }
      })
    }

    function notify(title: string, options: object) {
      const notification = new Notification(title, options)
      notification.onclick = function () {
        // 商品
        if (type === 9) {
          linkEcommerce(`/detail/${content.productId}`)
          // router.push(`/detail/${content.productId}`)
        } else {
          // 详情
          linkCommunity(`/content/${content.contentId}`)
          // router.push(`/content/${content.contentId}`)
        }
      }
      notification.onerror = function (error) {
        console.error('notification error: ', error)
      }
    }
  }

  const linkCommunity = (link: string) => {
    // 如果是电商，则跳转到社区站
    if (props.type === 'ecommerce') {
      window.location.href = `${props.base}${link}`
    } else {
      router.push(link)
    }
  }

  const linkEcommerce = (link: string) => {
    // 如果是社区，则跳转到电商站
    if (props.type === 'community') {
      window.location.href = `${props.base}${link}`
    } else {
      router.push(link)
    }
  }

  // 点击消息的图片
  const clickNotice = (msgId: string, contentId: string, item: NoticeItem) => {
    item.readFlag = 1
    readNotice(msgId)
    // getDetail(contentId);
    closeNotice()
    // eventBus.trigger('toggleDrawer')
    // 关注
    if ([0, 100].includes(item.type)) {
      if (item.payloadJson.landing_url) {
        const urlObj = new URL(item.payloadJson.landing_url)
        linkCommunity(urlObj.pathname + urlObj.search + urlObj.hash)
        return false
      }
      return false
    }
    if (item.type === 10 || item.type === 11) {
      return false
    }
    // 评论
    if (item.type === 12 || item.type === 13) {
      linkCommunity(`/content/${contentId}?commentId=${item.info.commentId}`)
      // router.push(`/content/${contentId}?commentId=${item.info.commentId}`)
      return false
    }
    // 订单
    if (item.type === 14 || item.type === 15 || item.type === 16) {
      linkEcommerce(`/order/detail/${item.info.orderId}`)
      // router.push(`/order/detail/${item.info.orderId}`)
      return false
    }
    // 订单发货
    if (item.type === 17) {
      linkEcommerce(`/order/logistics/${item.info.orderId}`)
      // router.push(`/order/logistics/${item.info.orderId}`)
      return false
    }
    // 榜单
    if (item.type === 22) {
      linkCommunity(`/creator?scrollToBottom=true`)
      return false
    }
    // 提及
    if (item.type === 23 && item.info.mentionType === 1) {
      linkCommunity(`/content/${contentId}?commentId=${item.info.commentId}`)
      return false
    }
    if (item.type === 23 && item.info.mentionType === 2) {
      linkCommunity(`/content/${contentId}`)
      return false
    }
    linkCommunity(`/content/${contentId}`)
    // router.push(`/content/${contentId}`)
  }

  const showFullScreenImage = (item: NoticeItem) => {
    if (item.payloadJson?.attachments?.image_url) {
      fullScreenImageVisible.value = true
      fullScreenImageSrc.value = item.payloadJson.attachments.image_url
    }
  }

  const clickAttachment = (attachment: any) => {
    if (attachment.type === 'qrcode') {
      fullScreenImageVisible.value = true
      fullScreenImageSrc.value = attachment.image_url
    }
  }

  const closeFullScreenImage = () => {
    fullScreenImageVisible.value = false
    fullScreenImageSrc.value = ''
  }
  // 点击产品详情链接
  const clickProductLink = (item: NoticeItem) => {
    item.readFlag = 1
    readNotice(item.msgId)
    closeNotice()
    // eventBus.trigger('toggleDrawer')
    linkEcommerce(`/detail/${item.info.productId}`)
    // router.push(`/detail/${item.info.productId}`)
  }
  // 点击消息头像
  const clickNoticeAvatar = (userId: string | number, item: NoticeItem) => {
    item.readFlag = 1
    linkCommunity(`/account/${userId}`)
    // router.push(`/account/${userId}`)
    closeNotice()
  }
  // 点击消息，标记已读
  const readNotice = async (id: string) => {
    const response = await _fetch('/aigc/api/message/read', {
      method: 'PUT',
      params: {
        msgIdList: id
      }
    })
    const res = await response.json()
    if (res.code === 200) {
      getNoticeNum()
      getAllNoticeNum()
    }
  }

  const followUser = (item: NoticeItem, val: boolean) => {
    item.userInfo.following = val
    item.readFlag = 1
    readNotice(item.msgId)
  }

  const isImageUrlValid = (url?: string) => {
    return url && url.startsWith('http') && !url.endsWith('.mp4')
  }
  // 一键已读
  const readAll = async () => {
    const response = await _fetch('/aigc/api/message/readAll', {
      method: 'PUT'
    })
    const res = await response.json()
    if (res.code === 200) {
      noticeStore.setUnReadCount(0)
      allUnreadNums.value = {
        systemCount: 0,
        normalCount: 0,
        tradeCount: 0
      }
      noticeType.value === 'user' && getNoticeItems()
      noticeType.value === 'official' && getOfficialItems()
      noticeType.value === 'order' && getOrderItems()
    }
  }

  const getNoticeIcon = (type: number) => {
    switch (type) {
      case 1:
        // 点赞
        return 'notice-like'
      case 4:
        // want it
        return 'notice-want'
      case 12:
        // 评论
        return 'notice-comment'
      case 13:
        // 回复评论
        return 'notice-comment'
      case 23:
        // 提及
        return 'notice-mention'
      default:
        return ''
    }
  }

  const _env_ = window._ENV_ || 'CN'
  const officialName = ref(_env_ === 'EN' ? 'Hitems' : '造好物官方')

  onBeforeUnmount(() => {
    noticeType.value = 'user'
    source?.close()
  })
</script>

<style lang="stylus" scoped>
  @import "./index.styl"
</style>
